import { useState } from "react";
import { useSupabase } from "../../../server/supabase/hooks";
import { isUUID } from "../../../utils/uuid";
import type { PopulatedProgram } from "../server/supabase-program-service";
import { SupabaseProgramService } from "../server/supabase-program-service";

export function usePopulatedProgramFromProgramId(programId?: string): PopulatedProgram | null {
  const [program, setProgram] = useState<PopulatedProgram | null>(null);

  useSupabase(
    async ({ supabase }) => {
      if (!programId) return;

      if (isUUID(programId)) {
        const { data } = await new SupabaseProgramService(supabase).getPopulated(programId);
        setProgram(data);
      } else {
        const { data } = await new SupabaseProgramService(supabase).getPopulatedByTitle(programId);
        setProgram(data);
      }
    },
    [programId],
  );

  return program;
}
